import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import locales from 'locales';

const Translate = ({ user, text, values }) => (
  <Fragment>
    {format(locales[user.language][text],values)}
  </Fragment>
);

function format(text, values) {
  for (let i = 0; i < values.length; i++) {
    text = text.replace(`{${i}}`, values[i]);
  }
  return text;
}

Translate.propTypes = {
  user: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  values: PropTypes.array,
};

Translate.defaultProps = {
  values: []
};

const mapSateToProps = state => ({
  user: state.user,
});

export default connect(mapSateToProps)(Translate);



// WEBPACK FOOTER //
// ./src/components/TranslateFormat.jsx